import React, { useRef, useState, useContext } from 'react'
import NavigationMenuButton from '../NavigationMenuButton/NavigationMenuButton'
import ApplicationContext from '../../utility/ContextProvider'
import './NavigationBar.scss'

interface NavigationBarProps {
  setNavigationOpen: any
  navigationOpen: any
}

function NavigationBar({ setNavigationOpen, navigationOpen }: NavigationBarProps) {
  const nameRef = useRef(null)

  const { darkMode, setDarkMode } = useContext(ApplicationContext)

  const [nameChanged, setNameChanged] = useState(false)

  const onHeaderClick = () => {
    if (nameChanged) {
      nameRef.current.innerText = 'Simms'
      setNameChanged(false)
    } else {
      nameRef.current.innerText = 'William'
      setNameChanged(true)
    }
  }

  const onHeaderDoubleClick = () => {
    if (darkMode) {
      setDarkMode(false)
    } else {
      setDarkMode(true)
    }
  }

  return (
    <div className='navigationBar'>
      <h2
        className='navigationBar__header'
        onAuxClick={onHeaderClick}
        onDoubleClick={onHeaderDoubleClick}
        ref={nameRef}>
        Simms
      </h2>
      <NavigationMenuButton setNavigationOpen={setNavigationOpen} navigationOpen={navigationOpen} />
    </div>
  )
}

export default NavigationBar
